const config = {
  API_URL: process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://signaltuner-back.azurewebsites.net/"
      : "https://localhost:7090/"),
};

export default config;
